import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelTorneosView from './PanelTorneosView';
import * as ROUTES from '../../../../router/Routes';

const PanelTorneosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelTorneos}
      routes={[ROUTES.juegosDeportivos, ROUTES.torneos]}
    >
      <PanelTorneosView />
    </ContainerTemplate>
  );
};

export default PanelTorneosModule;
